export { default } from '@shikijs/langs/docker'
